import { render, staticRenderFns } from "./WeeksNav.vue?vue&type=template&id=a29b35da"
import script from "./WeeksNav.vue?vue&type=script&lang=js"
export * from "./WeeksNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a29b35da')) {
      api.createRecord('a29b35da', component.options)
    } else {
      api.reload('a29b35da', component.options)
    }
    module.hot.accept("./WeeksNav.vue?vue&type=template&id=a29b35da", function () {
      api.rerender('a29b35da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/partials/WeeksNav.vue"
export default component.exports